var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.header)?_c('NebulaTitleBlock',{staticClass:"page-subheader__title",attrs:{"type":"section","title":_vm.header}}):_vm._e(),(_vm.description)?_c('p',{staticClass:"page-subheader__description"},[_vm._v(" "+_vm._s(_vm.description)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }